import "app/javascript/components/themes.css.ts.vanilla.css!=!../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/javascript/components/themes.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA32SzU7DMBCE7zzFSj5Xih3/LqfWP6+BgEIpFBKaAmkR746sColNV5Fv345GM+vFfdcd4PsKYLG40afj4DYNgmjb9vo/kwjCWkuYQhAhBMJaBBFjDJFijSCyNyp4gg2CSFFqJwm2CKKUQphDEEsfgqUO/izNxREcEIRbmqw1wbe1RTRGK4LvamG3SonieybGujJTH8EPFavSlIbgR772hq/9VE1WWeVM8JZv/sw3f+Er7viKr3zuNz53xyfpee93BKn6kbA9gtQTNiBIO2EHBNVM2AeC7EcYut12fXl4n2TKnOAXEUxveSRTZiVHIkg+2UQdTkTAbE821OLyAKQkCmbVUiGoeUV7XuecRCP4eYUhQf4+9+cX6TdIJC0EAAA=\"}!../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
import "app/javascript/components/pages/counseling/CounselingLP/style.css.ts.vanilla.css!=!../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"app/javascript/components/pages/counseling/CounselingLP/style.css.ts.vanilla.css\",\"source\":\"#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\"}!../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var About = '_1o7lsgx';
export var AboutSectionSubTitle = '_1o7lsg10';
export var AboutTop = '_1o7lsgy';
export var AdditionalInfo = '_1o7lsg1n';
export var AdditionalInfoTop = '_1o7lsg1o';
export var ArrowIcon = '_1o7lsg2w';
export var ArrowIconBox = '_1o7lsg2v';
export var Bonus = '_1o7lsg26';
export var BonusBadge = '_1o7lsg28';
export var BonusDescription = '_1o7lsg2h';
export var BonusHead = '_1o7lsg2a';
export var BonusHeadMarker = '_1o7lsg2b';
export var BonusInfo = '_1o7lsg2j';
export var BonusMain = '_1o7lsg27';
export var BonusTitle = '_1o7lsg2c';
export var BonusTitleLeft = '_1o7lsg2f';
export var BonusTitleMarker = '_1o7lsg2d';
export var BonusTitlePrefix = '_1o7lsg2e';
export var BonusTitleRight = '_1o7lsg2g';
export var BonusTop = '_1o7lsg29';
export var BonusWorning = '_1o7lsg2k';
export var CalcContent = '_1o7lsg3j';
export var CalcContentSP = '_1o7lsg3k';
export var Case = '_1o7lsg19';
export var CaseDetail = '_1o7lsg1k';
export var CaseDetails = '_1o7lsg1j';
export var CaseIcon = '_1o7lsg1l';
export var CaseLink = '_1o7lsg1p';
export var CaseText = '_1o7lsg1m';
export var Cases = '_1o7lsg18';
export var CounselingExamples = '_1o7lsg15';
export var CounselingTypeIcon = '_1o7lsg13';
export var CounselingTypeIcons = '_1o7lsg12';
export var CounselingTypeText = '_1o7lsg14';
export var CounselingTypes = '_1o7lsg11';
export var Devider = '_1o7lsg2i';
export var Flow = '_1o7lsg2l';
export var Footer = '_1o7lsg6';
export var FooterLink = '_1o7lsgc';
export var FooterLinkArea = '_1o7lsga';
export var FooterLinkInfo = '_1o7lsgb';
export var FooterOffer = '_1o7lsg7';
export var FooterOfferBadge = '_1o7lsg8';
export var FooterOfferPrefix = '_1o7lsg9';
export var HelpLink = '_1o7lsg1r';
export var HelpLinkBox = '_1o7lsg1q';
export var HelpLinkText = '_1o7lsg3q';
export var Layout = '_1o7lsg0';
export var MainVisual = '_1o7lsgd';
export var MainVisualClockIcon = '_1o7lsgi';
export var MainVisualContents = '_1o7lsge';
export var MainVisualContentsSP = '_1o7lsgv';
export var MainVisualOffer = '_1o7lsgp';
export var MainVisualOfferBadge = '_1o7lsgt';
export var MainVisualOfferMarker = '_1o7lsgr';
export var MainVisualOfferMarkerRight = '_1o7lsgs';
export var MainVisualOfferPrefix = '_1o7lsgq';
export var MainVisualPhoto = '_1o7lsgu';
export var MainVisualPhotoSP = '_1o7lsgw';
export var MainVisualTextArea = '_1o7lsgf';
export var MainVisualTitle = '_1o7lsgm';
export var MainVisualTitleMain = '_1o7lsgn';
export var MainVisualTitleSub = '_1o7lsgo';
export var MainVisualTop = '_1o7lsgg';
export var MainVisualTopTime = '_1o7lsgh';
export var MainVisualTopTimeText = '_1o7lsgj';
export var MainVisualTopTimeTextTime = '_1o7lsgk';
export var MainVisualTopTimeTextUnit = '_1o7lsgl';
export var MenuItem = '_1o7lsg3';
export var MenuLink = '_1o7lsg4';
export var MenuLinkActive = '_1o7lsg5';
export var MenuList = '_1o7lsg2';
export var NaviMenu = '_1o7lsg1';
export var Offer = '_1o7lsg1f';
export var OfferBubble = '_1o7lsg1g';
export var OfferText = '_1o7lsg1h';
export var Pricing = '_1o7lsg2x';
export var PricingCalcIcon = '_1o7lsg35';
export var PricingContent = '_1o7lsg2y';
export var PricingExample = '_1o7lsg39';
export var PricingExampleCalc = '_1o7lsg3f';
export var PricingExampleContent = '_1o7lsg3b';
export var PricingExampleImage = '_1o7lsg3d';
export var PricingExampleItem = '_1o7lsg3g';
export var PricingExampleRow = '_1o7lsg3c';
export var PricingExampleText = '_1o7lsg3e';
export var PricingExampleTitle = '_1o7lsg3a';
export var PricingExamples = '_1o7lsg38';
export var PricingFooter = '_1o7lsg3n';
export var PricingFooterLinkArea = '_1o7lsg3o';
export var PricingIllustration = '_1o7lsg2z';
export var PricingIllustrationSp = '_1o7lsg30';
export var PricingIllustrationText = '_1o7lsg36';
export var PricingIllustrationTextTop = '_1o7lsg37';
export var PricingIllustrationTop = '_1o7lsg31';
export var PricingItem = '_1o7lsg32';
export var PricingItemCalcContent = '_1o7lsg3i';
export var PricingItemCalcIcon = '_1o7lsg3l';
export var PricingItemCalcLabel = '_1o7lsg3h';
export var PricingItemIcon = '_1o7lsg34';
export var PricingItemLabel = '_1o7lsg33';
export var PricingWarning = '_1o7lsg3m';
export var RecomendSupporterCard = '_1o7lsg24';
export var RecomendSupporterNote = '_1o7lsg22';
export var RecomendSupporterTitle = '_1o7lsg21';
export var RecomendSupporters = '_1o7lsg23';
export var RecomendSupportersLink = '_1o7lsg25';
export var Request = '_1o7lsg1a';
export var RequestBubble = '_1o7lsg1b';
export var RequestImage = '_1o7lsg1d';
export var RequestText = '_1o7lsg1c';
export var SectionSubTitle = '_1o7lsg16';
export var SectionSubTitleText = '_1o7lsg17';
export var SectionTitle = '_1o7lsgz';
export var SpOnly = '_1o7lsg3r';
export var StepCard = '_1o7lsg2n';
export var StepDescription = '_1o7lsg2s';
export var StepFooter = '_1o7lsg2t';
export var StepFooterLink = '_1o7lsg2u';
export var StepName = '_1o7lsg2q';
export var StepNameSub = '_1o7lsg2r';
export var StepNumber = '_1o7lsg2p';
export var StepTitle = '_1o7lsg2o';
export var Steps = '_1o7lsg2m';
export var Supporter = '_1o7lsg1v';
export var SupporterAvatar = '_1o7lsg1i';
export var SupporterCopy = '_1o7lsg1y';
export var SupporterCopyIcon = '_1o7lsg1z';
export var SupporterCopyText = '_1o7lsg20';
export var SupporterCopys = '_1o7lsg1x';
export var SupporterIndexLink = '_1o7lsg3p';
export var SupporterInfos = '_1o7lsg1w';
export var SupporterSectionSubTitle = '_1o7lsg1u';
export var SupporterSectionTitle = '_1o7lsg1t';
export var SupporterTop = '_1o7lsg1s';
export var UserAvatar = '_1o7lsg1e';